<div class="collections-deliveries-preview-container">
  <div class="preview-header">
    <span class="preview-title">{{ 'bikeshop.workshop.jobcard.collections_deliveries' | translate }}</span>
  </div>
  
  <div class="preview-content">
    <!-- Collection Info -->
    <div class="service-item" *ngIf="hasCollectionData()">
      <div class="service-header">
        <span class="service-type">{{ 'bikeshop.rentals.booking.collection_information' | translate }}</span>
        <span class="status-badge" [ngClass]="getStatusClass(collectionsDeliveries.collectionInfo.statusID)">
          {{ getStatusLabel(collectionsDeliveries.collectionInfo.statusID, 'collection') }}
        </span>
      </div>
      
      <div class="service-details">
        <div class="detail-row" *ngIf="collectionsDeliveries.collectionInfo.scheduleDate">
          <span>{{ collectionsDeliveries.collectionInfo.scheduleDate | date: countryData.AngularDateFormat }}</span>
          <span *ngIf="collectionsDeliveries.collectionInfo.scheduleTimeSlotStart && collectionsDeliveries.collectionInfo.scheduleTimeSlotEnd" 
                class="time-slot">
            {{ formatTimeSlot(collectionsDeliveries.collectionInfo.scheduleTimeSlotStart, collectionsDeliveries.collectionInfo.scheduleTimeSlotEnd) }}
          </span>
        </div>
        
        <div class="detail-row" *ngIf="collectionsDeliveries.collectionInfo.fullAddress">
          <span class="address">{{ truncateAddress(collectionsDeliveries.collectionInfo.fullAddress) }}</span>
        </div>
        
        <div class="detail-row" *ngIf="collectionsDeliveries.collectionInfo.notes">
          <span class="notes">{{ collectionsDeliveries.collectionInfo.notes | slice:0:100 }}{{ collectionsDeliveries.collectionInfo.notes.length > 100 ? '...' : '' }}</span>
        </div>
      </div>
    </div>

    <!-- Delivery Info -->
    <div class="service-item" *ngIf="hasDeliveryData()">
      <div class="service-header">
        <span class="service-type">{{ 'bikeshop.rentals.booking.delivery_information' | translate }}</span>
        <span class="status-badge" [ngClass]="getStatusClass(collectionsDeliveries.deliveryInfo.statusID)">
          {{ getStatusLabel(collectionsDeliveries.deliveryInfo.statusID, 'delivery') }}
        </span>
      </div>
      
      <div class="service-details">
        <div class="detail-row" *ngIf="collectionsDeliveries.deliveryInfo.scheduleDate">
          <span>{{ collectionsDeliveries.deliveryInfo.scheduleDate | date: countryData.AngularDateFormat }}</span>
          <span *ngIf="collectionsDeliveries.deliveryInfo.scheduleTimeSlotStart && collectionsDeliveries.deliveryInfo.scheduleTimeSlotEnd" 
                class="time-slot">
            {{ formatTimeSlot(collectionsDeliveries.deliveryInfo.scheduleTimeSlotStart, collectionsDeliveries.deliveryInfo.scheduleTimeSlotEnd) }}
          </span>
        </div>
        
        <div class="detail-row" *ngIf="collectionsDeliveries.deliveryInfo.fullAddress">
          <span class="address">{{ truncateAddress(collectionsDeliveries.deliveryInfo.fullAddress) }}</span>
        </div>
        
        <div class="detail-row" *ngIf="collectionsDeliveries.deliveryInfo.notes">
          <span class="notes">{{ collectionsDeliveries.deliveryInfo.notes | slice:0:100 }}{{ collectionsDeliveries.deliveryInfo.notes.length > 100 ? '...' : '' }}</span>
        </div>
      </div>
    </div>

    <!-- No Data Message -->
    <div class="no-data-preview" *ngIf="!hasCollectionData() && !hasDeliveryData()">
      <span>{{ 'bikeshop.collections.no_collections_deliveries_setup' | translate }}</span>
    </div>
  </div>
</div>
